import { callApi } from 'utils/api'
import crud from './_crud'

const entity = 'currency_parameter'

const actions = crud(
	entity,
	'el parámetro de moneda',
	'los parámetros de moneda'
)

const upsert = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/upsert`, {
			method: 'PUT',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),
		})

		dispatch({
			type: 'UPDATE_ITEM',
			payload: res.body,
		})

		return res.body
	}
}

export default { ...actions, upsert }
